export const RULE_11 = [
  [true, false, false],
  [false, true, false],
  [false, false, true],
];

export const RULE_12 = [
  [false, false, false],
  [false, true, false],
  [false, false, false],
];

export const RULE_21 = [
  [true, false, false],
  [false, false, false],
  [true, false, true],
];
